<template>
    <div class="container-header">
        <div class="img-logo login" @click="movePage('/')">
        </div>
        <div class="btn-header mr12 alarm" @click="movePage('/alarm')"></div>
        <div class="btn-header menu" @click="onMenu()"></div>
        <subscript-modal></subscript-modal>
        <update-temp-pwd-modal></update-temp-pwd-modal>
        <auth-certificate-modal></auth-certificate-modal>
    </div>
</template>


<script>

import AuthMixins from "@/mixins/AuthMixins";
import popupMixin from "@/mixins/popupMixin.js";
import SubscriptModal from "@/components/modal/SubscriptModal.vue";
import AuthCertificateModal from "@/components/modal/AuthCertificateModal.vue";
import util from "@/mixins/util.js";
import UpdateTempPwdModal from "@/components/modal/UpdateTempPwdModal.vue";

export default {
    name: "PageHeader",
    mixins: [AuthMixins, popupMixin],
    components: {
      UpdateTempPwdModal,
        SubscriptModal,
        AuthCertificateModal,
    },
    inject: [],
    provide() {
        return {}
    },
    props: {
        msg: String,
        BackEvent: {type: null, default: false},
        headerTitle: {
            default: null,
        },
        header_back: {
            type: Boolean,
            default: false,
        },
        header_main_back: {
            type: Boolean,
            default: false,
        },
        header_logo: {
            type: Boolean,
            default: false,
        },
        step_back: {
            type: Boolean,
            default: false,
        },
        header_select: {
            type: Boolean,
            default: false,
        },
        header_btn: {
            type: Boolean,
            default: false,
        },
        modal_back: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {}
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
        if (this.UserInfo !== null) {
            if (this.UserInfo.mbIsVerify != 1 || this.isPastDate(this.UserInfo.mbCertificationDate)) {
                this.$vfm.show('auth-certificate-modal');
            }
        }

    },
    beforeUnmount() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        onMenu() {
            this.scrollMoveTop();
            this.$vfm.show('menu-modal')

        },
        movePage(path) {
            // this.scrollMoveTop();
            this.$router.push(path);
        },
        backEvent() {
            if (this.BackEvent) {
                this.BackEvent();
                return false;
            }
            if (this.$route.path === '/') {
                return false;
            }
            // this.$root.$children[0].hasBack = true;
            this.$router.back();
        },
        scrollMoveTop() {
            $('html').animate({scrollTop: 0}, 300);
        },
        moveHome() {
            this.scrollMoveTop();
            if (this.$route.path != '/') {
                this.$router.push('/')
            }
        },

        isPastDate(date) {
            const oneYearInMs = 365 * 24 * 60 * 60 * 1000;
            const currentDate = new Date();
            const targetDate = new Date(date);
            const diffInMs = currentDate - targetDate;

            return diffInMs >= oneYearInMs;
        }
    },
    watch: {},
}
</script>

<style scoped></style>
